import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { type DealFormDataWithTargeting, dealFormField } from '@openx/types/deal';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DealGroupContainer } from '../../../components/DealGroup/DealGroupContainer';
import { useDealContext } from '../../../utils/context/DealContext';
import { getDealsLabels } from '../../utils/dealFormUtils';

export const ReadOnlyIdSectionContent = () => {
  const { t } = useTranslation();
  const { useDealFormSelector } = useDealContext();

  const {
    dealForm: { currentDeal },
  } = useDealFormSelector();
  const dealUid = currentDeal?.uid || '';
  const externalDealId = currentDeal?.deal_id || '';

  const group =
    useWatch<DealFormDataWithTargeting, typeof dealFormField.METADATA_GROUP_DEAL>({
      name: dealFormField.METADATA_GROUP_DEAL,
    }) || [];

  const dealsLabels = useMemo(() => getDealsLabels(t), [t]);

  if (group.length > 1) {
    return (
      <FormSection divider title={t('IDs')} rightColumnSize={RIGHT_COLUMN_WIDTH + 1}>
        <DealGroupContainer group={group} dealId={externalDealId} dealUid={dealUid} isEdit />
      </FormSection>
    );
  }

  return (
    <FormSection divider title={t('IDs')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
      <RHFTextField
        name={dealFormField.DEAL_ID}
        label={dealsLabels[dealFormField.DEAL_ID]}
        fullWidth
        dataTest="deal-id"
        disabled
      />
    </FormSection>
  );
};
